import { TabsProps } from "antd";
import { ReactNode } from "react";

type CustomTabsRenderProps = TabsProps["renderTabBar"];
export default function CustomTabsRender(
  tabsProps: CustomTabsRenderProps,
  DefaultTabBar: any,
  children: ReactNode
) {
  return (
    <div className="flex gap-4 items-center">
      <DefaultTabBar {...tabsProps} className="mb-0" />
      {children}
    </div>
  );
}
